import React from 'react';

const ParaQueEneagrama = () => {
  return (
    <div className="section-container">
      <h2>¿Para qué sirve el Eneagrama?</h2>
      <p>
        El Eneagrama no es solo un sistema para clasificar personalidades, sino una poderosa herramienta de autoconocimiento y transformación. Nos permite comprender los mecanismos del ego que condicionan nuestra vida y limitan nuestro potencial, abriéndonos el camino hacia una mayor libertad interior.
      </p>

      <h3>🔍 Sus principales beneficios</h3>

      <ul>
        <li>
          <strong>1️⃣ Autoconocimiento profundo 🧠</strong>
          <p>Nos ayuda a identificar patrones inconscientes de pensamiento, emoción y comportamiento que influyen en nuestras decisiones y en nuestra manera de relacionarnos con el mundo.</p>
        </li>
        <li>
          <strong>2️⃣ Comprender la neurosis 💭</strong>
          <p>Explica cómo cada eneatipo se ha formado como una respuesta a heridas emocionales de la infancia, permitiéndonos sanar y evolucionar.</p>
        </li>
        <li>
          <strong>3️⃣ Mejorar las relaciones 💬</strong>
          <p>Favorece una comunicación más auténtica y empática, al enseñarnos a comprender mejor a los demás y a gestionar nuestras emociones en los vínculos personales y profesionales.</p>
        </li>
        <li>
          <strong>4️⃣ Transformación personal ✨</strong>
          <p>No es solo un mapa de la personalidad, sino una guía para el crecimiento. Nos ayuda a trascender el ego y conectar con nuestra verdadera esencia.</p>
        </li>
        <li>
          <strong>5️⃣ Herramienta de Coaching 🏥</strong>
          <p>Utilizado en Coaching, facilita la exploración de conflictos emocionales, proporcionando un camino claro hacia la sanación y el bienestar.</p>
        </li>
      </ul>

      <p>
        El Eneagrama es una brújula para vivir con mayor conciencia, ayudándonos a romper con automatismos y a elegir un camino más auténtico y alineado con nuestra esencia.
      </p>

      <h3>🌿 Conócete. Transfórmate. Vive con propósito</h3>
    </div>
  );
};

export default ParaQueEneagrama;
